var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWbnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 0C77.6162 0 100 22.3838 100 50C100 77.6162 77.6162 100 50 100C22.3838 100 0 77.6162 0 50C0 22.3838 22.3838 0 50 0Z",
    fill: "#F0B90B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.48 50.0001L27.516 63.2213L38.75 69.8318V77.5722L20.9415 67.1275V46.1339L27.48 50.0001ZM27.48 36.779V44.4833L20.9375 40.6131V32.9088L27.48 29.0386L34.0545 32.9088L27.48 36.779ZM43.4415 32.9088L49.984 29.0386L56.5585 32.9088L49.984 36.779L43.4415 32.9088Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2075 60.4809V52.7405L38.75 56.6107V64.315L32.2075 60.4809ZM43.4415 72.6043L49.984 76.4745L56.5585 72.6043V80.3086L49.984 84.1788L43.4415 80.3086V72.6043ZM65.9415 32.9088L72.484 29.0386L79.0585 32.9088V40.6131L72.484 44.4833V36.779L65.9415 32.9088ZM72.484 63.2213L72.52 50.0001L79.0625 46.1299V67.1235L61.254 77.5682V69.8278L72.484 63.2213Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7925 60.4806L61.25 64.3148V56.6104L67.7925 52.7402V60.4806Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7925 39.5192L67.8285 47.2596L56.5625 53.8702V67.1234L50.02 70.9575L43.4775 67.1234V53.8702L32.2115 47.2596V39.5192L38.782 35.649L49.98 42.2916L61.246 35.649L67.8205 39.5192H67.7925ZM32.2075 26.3021L49.984 15.8213L67.7925 26.3021L61.25 30.1722L49.984 23.5296L38.75 30.1722L32.2075 26.3021Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWbnb);
export default __webpack_public_path__ + "static/media/wbnb.c5dd1e31348c314837991aa4b3092624.svg";
export { ForwardRef as ReactComponent };